import { AxiosError } from "axios";
import { getErrorMessage } from "utils/error";

const OWNER_LEAD_CANNOT_HAVE_PROPERTY =
  "Owner leads can't be linked to a property or unit. Remove the property/unit selection before saving.";
const LEAD_TYPE_ERROR_COPY: Record<string, string> = {
  lead_type_change_not_allowed:
    "Owner leads can't be changed to another type, and leads can't be changed to Owner.",
  lead_type_locked_application_started:
    "This lead has started a rental application, so it can't be switched to Realtor.",
  realtor_lead_cannot_apply: "Realtor leads can't be invited to apply."
};
const OWNER_LEADS_FEATURE_DISABLED =
  "The Owner Leads feature is not enabled for this partner. Contact your admin to enable it.";

/**
 * Maps the owner-lead and lead-type backend failures to friendly copy, falling
 * back to the generic extractor for everything else. The feature-gate 403 has
 * no error code, so it's only surfaced for owner operations to avoid mislabeling
 * an unrelated permission 403 on the shared create/update flow.
 */
export const getLeadMutationErrorMessage = (
  error: unknown,
  { isOwnerLead = false }: { isOwnerLead?: boolean } = {}
): string => {
  if (error instanceof AxiosError) {
    if (isOwnerLead && error.response?.status === 403)
      return OWNER_LEADS_FEATURE_DISABLED;
    const code = error.response?.data?.error?.code;
    if (code === "owner_lead_cannot_have_property")
      return OWNER_LEAD_CANNOT_HAVE_PROPERTY;
    if (typeof code === "string" && LEAD_TYPE_ERROR_COPY[code])
      return LEAD_TYPE_ERROR_COPY[code];
  }
  return getErrorMessage(error);
};
